import styled from 'styled-components';
import { ImageUtils } from '../../../utils/ImageUtils';
import { useTextVariant } from '../../../hook/useTextVariant';
import { HEADER_CONSTANTS } from '../../../constants/header';

export const HeaderMobile = () => {
  const { getText } = useTextVariant(HEADER_CONSTANTS, true);

  return (
    <HeaderContainer>
      <LogoContainer>
        <Logo src={ImageUtils.LogoMobile} />
      </LogoContainer>
      <Table>
        <colgroup>
          <col style={{ width: '50%' }} />
          <col style={{ width: '50%' }} />
        </colgroup>
        <thead>
          <tr>
            <TableHeader>{getText('satelliteTitle')}</TableHeader>
            <TableHeader>{getText('mainEventTitle')}</TableHeader>
          </tr>
        </thead>
        <tbody>
          <tr>
            <TableCell1>
              <TableTopText>
                {getText('satelliteDate1')}
                <br />
                <span>{getText('satelliteTime1')}</span>
                <br />
                {getText('satelliteDate2')}
                <br />
                <span>{getText('satelliteTime2')}</span>
                <CenterRow>
                  <img src={ImageUtils.ShowDownApp} alt="" />
                  <TableBottomTex>{getText('satelliteApp')}</TableBottomTex>
                </CenterRow>
              </TableTopText>
            </TableCell1>
            <TableCell1 style={{ verticalAlign: 'middle' }}>
              <TableTopDateText>{getText('mainEventDay')}</TableTopDateText>
              <CircleText>{getText('mainEventVenue')}</CircleText>
              <LocationText>{getText('mainEventDetail')}</LocationText>
            </TableCell1>
          </tr>
        </tbody>
      </Table>
    </HeaderContainer>
  );
};

const HeaderContainer = styled.header`
  padding: 0 5px;
  padding-top: 39px;
`;

const Logo = styled.img`
  width: 293px;
`;

const LogoContainer = styled.div`
  display: flex;
  text-align: center;
  flex-direction: column;
  align-items: center;
  position: relative;
  margin-bottom: 2px;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  text-align: left;
  position: relative;
  margin-bottom: 5px;

  tbody {
    height: 108px;
  }
`;

const TableHeader = styled.th`
  background: #2c52b3;
  color: rgba(255, 255, 255, 0.8);
  text-align: center;
  font-weight: 400;
  font-size: 13px;
  height: 24px;
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  box-shadow: 0px 1px 0px rgba(0, 0, 0, 0.4);
`;

const TableCell = styled.td`
  text-align: center;
  background: rgba(0, 0, 0, 0.3);
  letter-spacing: -0.05em;
  color: rgba(255, 255, 255, 0.7);
  font-size: 12px;
  line-height: 20px;
`;

const TableCell1 = styled(TableCell)`
  vertical-align: top;
`;

const CenterRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 5px;

  img {
    width: 25px;
    margin-right: 10px;
  }

  margin-top: 7px;
`;

const TableTopText = styled.div`
  color: rgba(255, 255, 255, 0.8);
  text-align: center;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  margin-top: 10px;

  span {
    color: rgba(255, 255, 255, 0.6);

    font-size: 14px;
    line-height: 20px;
  }
`;

const TableTopDateText = styled(TableTopText)`
  font-size: 16px;
  line-height: 24px;
`;

const TableBottomTex = styled.p`
  color: rgba(255, 255, 255, 0.6);
  text-align: center;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
`;

const CircleText = styled.p`
  color: rgba(255, 255, 255, 0.8);
  display: inline-block;
  text-align: center;
  font-weight: 400;
  border: 1px solid rgba(255, 255, 255, 0.4);
  border-radius: 30px;
  font-size: 12px;
  line-height: 18px;
  height: 20px;
  margin-top: 4px;
  margin-bottom: 4px;
  padding-left: 10px;
  padding-right: 10px;
`;

const LocationText = styled.p`
  color: rgba(255, 255, 255, 0.6);
  text-align: center;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
`;
